module.exports = __webpack_public_path__ + "img/project_6.a3316a53.jpg";